export const GET_SITES = 'dt/sites/GET_SITES';
export const SET_SITES = 'dt/sites/SET_SITES';
export const CREATE_SITE = 'dt/sites/CREATE_SITE';
export const SET_CREATED_SITE = 'dt/sites/SET_CREATED_SITE';
export const SET_ACTIVE_SITE = 'dt/sites/SET_ACTIVE_SITE';
export const SET_ACTIVE_SITE_ID = 'dt/sites/SET_ACTIVE_SITE_ID';
export const UPDATE_SITE = 'dt/sites/UPDATE_SITE';
export const DELETE_SITE = 'dt/sites/DELETE_SITE';
export const REMOVE_SITE = 'dt/sites/REMOVE_SITE';
export const DOWNLOAD_SITES_TEMPLATE = 'dt/sites/DOWNLOAD_SITES_TEMPLATE';
export const UPLOAD_SITES_EXCEL_SHEET = 'dt/sites/UPLOAD_SITES_EXCEL_SHEET';
export const REQUEST_MODEL_THUMBNAIL = 'dt/models/REQUEST_MODEL_THUMBNAIL';
export const RECEIVE_MODEL_THUMBNAIL = 'dt/models/RECEIVE_MODEL_THUMBNAIL';

export const requestSites = (callback) => ({ type: GET_SITES, callback });

export const requestModelThumbnail = (modelId, versionId) => ({
  type: REQUEST_MODEL_THUMBNAIL,
  modelId,
  versionId,
});

export const receiveModelThumbnail = (modelId, versionId, src) => ({
  type: RECEIVE_MODEL_THUMBNAIL,
  modelId,
  versionId,
  src,
});

export const setSites = (sites) => ({ type: SET_SITES, sites });

export const createSite = (site, callback) => ({ type: CREATE_SITE, site, callback });

export const setCreatedSite = (createdSite) => ({ type: SET_CREATED_SITE, createdSite });

export const setActiveSite = (siteId) => ({ type: SET_ACTIVE_SITE, siteId });

export const setActiveSiteId = (siteId) => ({ type: SET_ACTIVE_SITE_ID, siteId });

export const updateSite = (siteId, site, callback) => ({
  type: UPDATE_SITE,
  siteId,
  site,
  callback,
});

export const deleteSite = (siteId) => ({ type: DELETE_SITE, siteId });

export const removeSite = (siteId) => ({ type: REMOVE_SITE, siteId });

export const downloadSitesExcel = () => ({ type: DOWNLOAD_SITES_TEMPLATE });

export const uploadSitesExcelFile = (file, realm) => ({
  type: UPLOAD_SITES_EXCEL_SHEET,
  file,
  realm,
});
